// extracted by mini-css-extract-plugin
export default {"price":"zba-z","onSale":"Aba-z","msrpLabelPrice":"Bba-z","msrpLabel":"Cba-z","originalPrice":"Dba-z"};